<template>
  <div>
    <v-card class="mt-4 mx-4 elevation-0">
      <v-card-title class="pl-4 pt-3" style="">
        <!-- <div>
          <div class="headline"><v-icon class="mr-3">contacts</v-icon> Exhibitions</div>
        </div> -->
        <!-- <v-spacer></v-spacer>
        <v-text-field append-icon="search" label="Search in Artists" single-line hide-details v-model="search" ></v-text-field> -->
      </v-card-title>
      <!-- <h1 class='headline ml-3 mt-4'><v-icon class="mr-3">contacts</v-icon> Exhibitions</h1> -->
      <index-table></index-table>
    </v-card>
  </div>
</template>

<script>
  // import axios from '@/utils/apiClient'
  import IndexTable from '@/components/exhibitions/IndexTable'
  export default {
    data: function () {
      return {
        // displayedData: [],
        // ownerships,
        // filteredTextArtwork: '',
        // filteredTextArtist: '',
        // selectedFilter: '',
        // artwork: {
        //   name: ''
        // },
        // artists: [],
        // artworks: [],
        // resultsArtworks: [],
        // resultsArtists: [],
        // editArtwork: false,
        // filterText: ''
     }
    },
    components: {
      IndexTable
    }
  }
</script>

<style scoped>
  h2 { padding:20px 0 0 20px; font-weight:100px;}
</style>



// WEBPACK FOOTER //
// src/components/exhibitions/Index.vue